export interface Product {
  id: number;
  sku: string;
  name: string;
  price?: number;
  // adicione outros campos que o Magento retorna se necessário
}

export interface MagentoSearchResponse {
  items: Product[];
  search_criteria: any;
  total_count: number;
}

export type ConditionType = 'eq' | 'like' | 'in' | 'gt' | 'lt';

const addFilter = (
  params: URLSearchParams,
  groupIdx: number,
  filterIdx: number,
  field: string,
  value: string,
  condition: ConditionType
): void => {
  const prefix = `searchCriteria[filter_groups][${groupIdx}][filters][${filterIdx}]`;

  params.append(`${prefix}[field]`, field);
  params.append(`${prefix}[value]`, value);
  params.append(`${prefix}[condition_type]`, condition);
};

// suggest true vem sem o objeto PRICE
export const magentoURLBuilder = ({
  typeSearch = 'term',
  term = '',
  internal_code = false,
  suggest = false,
  sortOrder = 'relevant',
  currentPage = 1,
  pageSize = 12
}: {
  typeSearch?: 'term' | 'list';
  term?: string;
  internal_code?: boolean;
  suggest?: boolean;
  sortOrder?: string;
  currentPage?: number;
  pageSize?: number;
}): URLSearchParams => {
  const params = new URLSearchParams();

  params.append('searchCriteria[currentPage]', String(currentPage));
  params.append('searchCriteria[pageSize]', String(pageSize));
  params.append('suggest', String(suggest));
  params.append('sortOrder', sortOrder);

  const cleanTerm = term.trim();
  const skuListValue = cleanTerm.split(/\s+/).join(',');
  const phraseLikeValue = `%${cleanTerm}%`;

  if (typeSearch === 'list') {
    addFilter(
      params,
      0,
      0,
      internal_code ? 'internal_code' : 'sku',
      skuListValue,
      'in'
    );
    return params;
  }

  addFilter(
    params,
    0,
    0,
    internal_code ? 'internal_code' : 'sku',
    skuListValue,
    'in'
  );
  addFilter(params, 0, 1, 'name', phraseLikeValue, 'like');

  // Como fica muito verboso com 3 filtros da 413 Request Entity Too Large
  // mas o filtro abaixo pesquisa por um trecho do SKU.
  // addFilter(params, 0, 2, 'sku', phraseLikeValue, 'like');

  return params;
};
